import { gql } from '@apollo/client';
import { QUOTE_FIELDS_FRAGMENT } from './quoteFragment';

export const GET_QUOTE_BY_ID = gql`
  query QuoteById($quoteId: ID!) {
    quote {
      quoteById(quoteId: $quoteId) {
        success
        error
        entity {
          ...QuoteFields
        }
      }
    }
  }
  ${QUOTE_FIELDS_FRAGMENT}
`;
